import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react';
import { getApiBaseUrl } from '../utils/apiBase';

export const productApi = createApi({
    reducerPath: 'productApi',
    baseQuery: fetchBaseQuery({baseUrl: getApiBaseUrl() || '/'}),
    endpoints: (builder) => ({
        getProductsList: builder.query({
            query: () => `/anuyog-products-list/`,
        }),
    }),
});
export const {useGetProductsListQuery} = productApi;
